import { unlockTherapistConstant } from 'src/redux/actions/constant';

const {
  POST_UNLOCK_THERAPIST_REQUEST,
  POST_UNLOCK_THERAPIST_SUCCESS,
  POST_UNLOCK_THERAPIST_FAILURE,
  POST_UNLOCK_THERAPIST_RESET,
  POST_UNLOCK_THERAPIST_LOADING,
} = unlockTherapistConstant;

const intialState: object = {
  response: null,
  isUpdatedUnlock: false,
  loading: false,
};

export const updateUnlockTherapistReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case POST_UNLOCK_THERAPIST_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isUpdatedUnlock: true,
        loading: false,
      };
    }
    case POST_UNLOCK_THERAPIST_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isUpdatedUnlock: false,
        loading: false,
      };
    }

    case POST_UNLOCK_THERAPIST_LOADING:
      return {
        ...state,
        loading: true,
      };

    case POST_UNLOCK_THERAPIST_RESET:
      return intialState;

    default:
      return state;
  }
};
